






































































import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AuthenticationModule, {
  AUTHENTICATION_MODULE_NAME
} from '@/store/modules/authentication.module';
import { REGISTERED_TAG_MODULE_NAME } from '@/store/modules/registered-tag.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import PublicGetTagMixin from '@/mixins/public-get-tag.mixin';
import { mapState } from 'vuex';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';
import VueRecaptcha from 'vue-recaptcha';
import PublicCancelMixin from '@/mixins/public-cancel.mixin';
import { routeName } from '@/constants/route.constants';

const authModule: AuthenticationModule = getModule(AuthenticationModule, store);

@Component({
  components: {
    VueRecaptcha
  },
  computed: {
    ...mapState(REGISTERED_TAG_MODULE_NAME, ['showLoading', 'errorResponse']),
    ...mapState(AUTHENTICATION_MODULE_NAME, {
      showAuthLoading: 'showLoading'
    }),
    siteKey(): string {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
    }
  }
})
export default class ViewAccessComponent extends mixins(
  PublicGetTagMixin,
  PublicCancelMixin
) {
  public showLoading: boolean;
  public showAuthLoading: boolean;
  //public errorResponse: BaseAPIErrorModel | null;
  public acceptedTerms = true;
  public disableClick = false;

  public $refs: {
    invisibleRecaptcha: HTMLFormElement;
  };

  public get tagCode(): string {
    return this.$route.params.tagCode;
  }

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public async onAcceptClick() {
    this.$refs.invisibleRecaptcha.execute();
  }

  public onCancelClick() {
    this.onCancel();
  }

  public async onVerify() {
    this.disableClick = true;

    await authModule.acceptTermsAction(this.acceptedTerms);
    //await this.getTagByCode(this.tagCode);

    await this.$router.replace({
      name: routeName.public.customer
    });

    this.disableClick = false;
  }
}
